import { Loader } from 'google-maps'
import styles from './range-map-style.json'
import './_range-map.scss'

class RangeMap {
  constructor(element, options = {}) {
    const { marker, lat, lng, apiKey, aircraft, radius } = options
    const center = {
      lat: +lat,
      lng: +lng,
    }

    new Loader(apiKey, {
      libraries: ['geometry'],
    })
      .load()
      .then(google => {
        const zoom = window.innerWidth < 1024 ? 1 : 2
        this.googleMap = new google.maps.Map(element, {
          center,
          zoom,
          styles,
          disableDefaultUI: true,
          minZoom: zoom,
        })

        this.mainMarker = new google.maps.Marker({
          map: this.googleMap,
          position: center,
          icon: {
            url: marker,
            size: new google.maps.Size(50, 50),
            origin: new google.maps.Point(0, 0),
            labelOrigin: new google.maps.Point(15, 70),
          },
          label: {
            text: aircraft,
            color: '#bd9973',
            fontSize: '24px',
            fontWeight: '300',
            fontFamily: 'proxima-nova',
          },
          animation: google.maps.Animation.DROP,
        })

        function circlePath(c, r, points) {
          const a = []
          const p = 360 / points
          let d = 0
          for (let i = 0; i < points; ++i, d += p) {
            a.push(google.maps.geometry.spherical.computeOffset(c, r, d))
          }
          return a
        }

        this.circle = new google.maps.Polygon({
          strokeColor: '#BD9973',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#47484E',
          fillOpacity: 0.4,
          map: this.googleMap,
          geodesic: true,
          path: circlePath(center, Number(radius) * 1000, 1440),
        })
      })
  }

  setCenter(latLng) {
    const maxLat = 30
    let centerLat = latLng.lat
    if (Math.abs(latLng.lat) > maxLat) {
      centerLat = Math.sign(latLng.lat) * maxLat
    }
    this.googleMap.setCenter({
      lng: latLng.lng,
      lat: centerLat,
    })

    this.mainMarker.setPosition(latLng)

    this.circle.setOptions({
      center: latLng,
    })
  }
}

export default RangeMap
